import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../../components/Loader';
import { fetchInvoice, getVatCodes } from '../../../Invoices/actions';
import { selectInvoice, selectVatCodes } from '../../../Invoices/selectors';
import { selectWork, selectWorks } from '../../../Api/selectors';
import { INVOICE_DIRECTIONS, REQUEST_INVOICE, REQUEST_VAT_CODES } from '../../../Invoices/constants';
import { VBox, HBox } from '../../../../components/Box';
import { performAction } from '../../../KanbanBoards/actions';
import { FormField } from '../../../../components/FormFields';
import { DeleteInvoiceModal } from '../../../Invoices/components/DeleteInvoiceModal';
import { Button } from '../../../../components/Buttons';
import { Euro } from '../../../../components/Icon';
import { Cell, List, Row } from '../../../../components/List';
import { getPropByName } from '../../../../utils/props';
import styles from './FinFacturerenModalBody.module.css';

const Container = styled.div`
  position: relative;
  width: 100%;

  .box1 {
    h2 {
      font-size: 16px;
      text-transform: uppercase;
    }
  }

  .list {
    width: 100%;
  }
`;

const TotalMarginContainer = styled.div`
  padding-bottom: 20px;
  font-size: 18px;
`;

const STATE = {
  invoice: {},
};

/* eslint-disable react/prefer-stateless-function */
class FIN_facturerenModalBodyComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchInvoice(result => {
      this.setState({ invoice: result });
    });
    this.props.getCode();
  }

  componentDidUpdate(prevProps, prevState) {}

  get vehicleSubject() {
    return this.state.invoice?.invoiceSubjects?.find(s => s.type == 'vehicle');
  }

  get costs() {
    return this.state.invoice?.invoiceSubjects?.filter(s => s.type !== 'vehicle');
  }

  get vatCodes() {
    return this.props.vatCodes ?? [];
  }

  getVatCodeLabel(code) {
    return this.vatCodes?.filter(vatCode => vatCode.code == code);
  }

  get otherCompany() {
    return this.state.invoice?.direction == INVOICE_DIRECTIONS.INCOMING
      ? this.state.invoice?.incomingCompany
      : this.state.invoice?.outgoingCompany;
  }

  get isExport() {
    const companyFrom = this.otherCompany?.company_from_eu?.toLowerCase();
    return companyFrom == 'eu' || companyFrom == 'outside_eu';
  }

  get isOutgoingExport() {
    return this.isExport && this.state.invoice?.direction == INVOICE_DIRECTIONS.OUTGOING;
  }

  isPurchaseStatement() {
    const isMargin =
      this.state.invoice?.invoiceSubjects?.find(s => s.type === 'vehicle' && s?.btwOrMarge === 'marge') ?? false;
    const isIndividualCompany =
      this.state.invoice?.incomingCompany?.properties?.find(p => p?.name?.name === 'company_type')?.value === 'individual';
    return (
      this.state.invoice?.direction === 'incoming' &&
      this.state.invoice?.subjectType === 'vehicle' &&
      isMargin &&
      isIndividualCompany
    );
  }

  calcInfo(subject, direction, options) {
    const isBTW = subject?.btwOrMarge === 'BTW';
    const isMarge = !isBTW;

    if (isMarge) {
      let subtotal =
        direction === 'outgoing' ? subject?.financial_price_marge_incl_bpm : subject?.financial_purchase_price_marge_bpm;

      if (options?.isOutgoingExport) {
        subtotal = subject?.financial_price_marge_incl_bpm;
      }
      if (options?.purchaseStatement) {
        subtotal = subject?.financial_purchase_price_marge_bpm;
      }

      return `€ ${this.formatAmount(subtotal)}`;
    }

    //is BTW
    let subtotal = subject?.price;
    return `€ ${this.formatAmount(subtotal)}`;
  }

  formatAmount(amount) {
    if ((!amount && amount !== 0) || Number.isNaN(amount)) {
      return null;
    }

    return amount.toFixed(2);
  }

  renderTotalMargin() {
    let totalMargin = this.state.invoice?.ledgersEntry?.totalMargin ?? 0;
    totalMargin = this.formatAmount(totalMargin);

    return (
      this.state.invoice?.direction === INVOICE_DIRECTIONS.OUTGOING && (
        <TotalMarginContainer>
          <HBox>
            <strong>{this.lbl('invoice.ledgers.totalMargin')}</strong>
            <Euro />
            <strong>{totalMargin}</strong>
          </HBox>
        </TotalMarginContainer>
      )
    );
  }

  render() {
    if (this.props.workInvoice) return <Loader small />;
    const invoice = this.state.invoice;

    return (
      <Container innerWidth={window.innerWidth}>
        <VBox>{this.renderTotalMargin()}</VBox>
        <List className="list">
          <Row key="vatCode">
            <Cell className={styles.cell}>{this.lbl('kanbanboards.cell.vat_code')}</Cell>
            <Cell className={styles.cellText}>
              {this.getVatCodeLabel(this.vehicleSubject?.subjectVat?.code)[0]?.description}
            </Cell>
          </Row>
          <Row key="subtotal-vat-price">
            <Cell className={styles.cell}>
              <strong>{this.lbl('kanbanboards.cell.subtotal')}</strong>
            </Cell>
            <Cell className={styles.cellText}>
              <span>
                {this.calcInfo(this.vehicleSubject, this.state.invoice?.direction, {
                  isOutgoingExport: this.isOutgoingExport,
                  purchaseStatement: this.isPurchaseStatement(),
                })}
              </span>
            </Cell>
          </Row>
          <Row key="vat-type">
            <Cell className={styles.cell}>
              <strong>{this.lbl('kanbanboards.cell.vat_type')}</strong>
            </Cell>
            <Cell className={styles.cellText}>
              <span>{this.props.invoice?.vehicle?.btwOrMarge}</span>
            </Cell>
          </Row>
        </List>
        <br />

        {this.costs?.map(cost => {
          return (
            <List key={cost?.id}>
              {['costType', 'vatCode', 'price'].map(prop => {
                if (prop == 'vatCode') {
                  return (
                    <Row key={prop}>
                      <Cell className={styles.cell}>
                        <strong>{this.lbl(prop)}</strong>
                      </Cell>
                      <Cell className={styles.cellText}>{this.getVatCodeLabel(cost.subjectVat?.code)[0]?.description}</Cell>
                    </Row>
                  );
                }

                if (prop == 'price') {
                  return (
                    <Row key={prop}>
                      <Cell className={styles.cell}>
                        <strong>{prop}</strong>
                      </Cell>
                      <Cell className={styles.cellText}>{`€ ${this.formatAmount(cost[prop])}`}</Cell>
                      <br />
                    </Row>
                  );
                }

                return (
                  <Row key={prop}>
                    <Cell className={styles.cell}>
                      <strong>{prop}</strong>
                    </Cell>
                    <Cell className={styles.cellText}>
                      <span>{cost[prop]}</span>
                    </Cell>
                  </Row>
                );
              })}
              <br />
            </List>
          );
        })}
      </Container>
    );
  }
}

FIN_facturerenModalBodyComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(ownProps.invoiceId),
    workInvoice: selectWorks([REQUEST_INVOICE, REQUEST_VAT_CODES]),
    vatCodes: selectVatCodes(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchInvoice(callback) {
      dispatch(fetchInvoice(ownProps.invoiceId, callback, { isUniqueGate: true }));
    },
    getCode() {
      dispatch(getVatCodes());
    },
    confirm(callback) {
      dispatch(
        performAction(
          ownProps.action?.id,
          ownProps.vehicle?.id,
          { regplate_code: ownProps.vehicle?.regplate_code || '' },
          callback,
        ),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const FIN_facturerenModalBody = compose(withConnect, withRouter)(FIN_facturerenModalBodyComp);
